export default __webpack_public_path__ + "static/media/aw.c3a4a478.svg";